/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import _ from 'lodash';
import CustomEntry from './custom/CustomEntry';
import Entry from './Entry';
import MultiEntry from './MultiEntry';
import PartyEntry from './custom/PartyEntry';
import DeclarationEntry from './custom/DeclarationEntry';
import { SubmissionSectionType } from './SubmissionSectionType';
import AttachmentsPreviewEntry from './custom/AttachmentsPreviewEntry';
/**
 * Summary entry selector that picks the right Entry type based on
 * type and sectionHeader.
 */
export default function EntrySelector({ entry, index, readOnly, customClassName }) {
  return (
    <>
      {entry?.type === SubmissionSectionType.ATTACHMENTS_PREVIEW && (
        <AttachmentsPreviewEntry entry={entry} readOnly={readOnly} customClassName={customClassName} />
      )}

      {entry?.type === SubmissionSectionType.PARTIES && (
        <PartyEntry key={entry.sectionHeader + index} entry={entry} readOnly={readOnly} />
      )}

      {entry?.type === SubmissionSectionType.ATTACHMENTS && (
        <CustomEntry
          type={SubmissionSectionType.ATTACHMENTS}
          title={entry.title}
          value={entry.value}
          icon={entry.icon}
          hasDivider={entry.divider}
          link={entry.link}
          linkTo={entry.linkTo}
          hideLinkTo={entry?.hideLinkTo}
          readOnly={readOnly}
        />
      )}

      {(entry?.type === SubmissionSectionType.DECLARATIONS || entry?.type === SubmissionSectionType.SEQLBIO) && (
        <DeclarationEntry key={entry.sectionHeader + index} entry={entry} readOnly={readOnly} />
      )}

      {/* header entry with multiple sub-entries */}
      {!entry?.type && entry?.sectionHeader && (
        <MultiEntry
          readOnly={readOnly}
          key={entry.sectionHeader + index}
          sectionHeader={entry.sectionHeader}
          items={entry.items}
          sectionIcon={entry.sectionIcon}
          sectionLinkTo={entry.sectionLinkTo}
          hideLinkTo={entry?.hideLinkTo}
        />
      )}

      {/* generic entry */}
      {!entry?.type && !entry?.sectionHeader && (!entry?.showFilled || !_.isEmpty(entry?.value)) && (
        <Entry
          key={index}
          title={entry?.title}
          value={entry?.value}
          type={entry?.type}
          onClick={entry?.onClick}
          noScroll={entry?.noScroll || !entry?.value}
          readOnly={readOnly}
          customClassName={customClassName}
          hideLinkTo={entry?.hideLinkTo}
        />
      )}
    </>
  );
}
